export default {
  edgesOtherText: '',
  showEdgesOtherLabel: false,
  showEdgesOtherTextbox: false,
  disableOtherParams: false,
  edgesOtherParamCode: '',
  edgeUnknownParamCode: '',
  edgewoundList: [],
};
